<div *ngIf="cell.text && cell.text != ''" class="flex flex-row">
    <button *ngIf="baseRoute" mat-icon-button color="accent" (click)="externalRedirect(baseRoute + '/' + cell.text)"
            matTooltip="{{ 'COMMON.LINK' | transloco }}" matTooltipPosition="above">
        <mat-icon svgIcon="feather:external-link"></mat-icon>
    </button>
    <app-id-table-template [isTable]="false" [id]="cell.text"></app-id-table-template>
</div>
